import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'customers';

// GET
export const getCustomers = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createCustomers = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateCustomers = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteCustomers = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data.data;
  } catch (error) {
    errorHandler(error);
  }
};

getCustomers.propTypes = {
  params: PropTypes.object.isRequired,
};

createCustomers.propTypes = {
  values: PropTypes.object.isRequired,
};

updateCustomers.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteCustomers.propTypes = {
  id: PropTypes.string.isRequired,
};
